import React, { PropTypes } from 'react';
import styled from 'styled-components';
import Breakpoint from '../../../utils/breakpoints';

import Menu from '../Menu/Sidebar/Menu';

const Sidebar = styled.div`
  width: 60px;
  z-index: 10000;
  flex-shrink: 0;
`;

/**
 * Composed {@link Menu} to be displayed on a Desktop Screen.
 * This will offset the other content on the page by 60px.
 */
class DesktopNavigation extends React.Component {
  state = {
    open: false,
  };

  closeSidebar = () => this.setState({ open: false });

  render() {
    return (
      <Breakpoint name="desktop">
        <Sidebar
          onMouseEnter={() => this.setState({ open: true })}
          onMouseLeave={() => this.setState({ open: false })}>
          <Menu
            {...this.props}
            open={this.state.open}
            onClose={this.closeSidebar}
            openedWidth="250px"
            closedWidth="60px"
          />
        </Sidebar>
      </Breakpoint>
    );
  }
}

DesktopNavigation.propTypes = {
  // The react router current location
  location: PropTypes.shape({
    pathname: React.PropTypes.string.isRequired,
  }).isRequired,
};

export default DesktopNavigation;



// WEBPACK FOOTER //
// ./src/components/common/Navigation/DesktopNavigation.js